import React from 'react';
import Feature from '../../components/feature/Feature';
import './features.css';

const featuresData = [
  {
    title: 'We ask the right questions',
    text: 'Our team will engage with you in a discussion about what direction you want oyur company to head.',
  },
  {
    title: 'Outreach',
    text: 'Over the years we have made a lot of quality connections that will help your brand grow.',
  },
  {
    title: 'The Team',
    text: 'We have an excellent team of experienced individuals that will give you the best service possible.',
  },
  {
    title: 'Homebrew Magic',
    text: 'With all the combined experience of our marketing team, we have what it takes to help your brand succeed.',
  },
];

const Features = () => (
  <div className="gpt3__features section__padding" id="features">
    <div className="gpt3__features-heading">
      <h1 className="gradient__text">The Future is Now and You Just Need to Realize It. Step into Your Future Today & Make it Happen.</h1>
      <p>The Homebrew Method</p>
    </div>
    <div className="gpt3__features-container">
      {featuresData.map((item, index) => (
        <Feature title={item.title} text={item.text} key={item.title + index} />
      ))}
    </div>
  </div>
);

export default Features;
